<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item><div style="display: inline-block;" @click="gotopage('/Goods/index.html')">商品管理</div></el-breadcrumb-item>
            <el-breadcrumb-item>供应商-商品</el-breadcrumb-item>
        </el-breadcrumb>

        <el-form :inline="true" :model="item" class="search">
            <el-row>
                <el-form-item label="商品状态">
                    <el-radio-group v-model="item.goodsStatus" @change="submit($event)">
                        <el-radio-button label="0">全部</el-radio-button>
                        <el-radio-button label="10">已下架</el-radio-button>
						<el-radio-button label="20">在售中</el-radio-button>
						<el-radio-button label="30">待审核</el-radio-button>
                    </el-radio-group>
                </el-form-item>
            </el-row>
            <el-form-item label="商品名称">
                <el-input v-model="item.name" placeholder="请输入商品名称"
                          size="small"></el-input>
            </el-form-item>
            <el-form-item label="价格区间">
                <el-row>
                    <el-col :span="11">
                        <el-input v-model="item.min" placeholder="最小值" ></el-input>
                    </el-col>
                    <el-col :span="2" style="display: flex;align-items: center;justify-content: center;height: 40px">
                        <span style="margin: 0 10px;">至</span>
                    </el-col>
                    <el-col :span="11">
                        <el-input v-model="item.max" placeholder="最大值"></el-input>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item label="商品分类">
                <el-cascader v-model="item.product_category_id"
                             placeholder="请选择"
                             :options="optionsProduct"
                             :props="filterProps"
                             clearable></el-cascader>
            </el-form-item>
            <el-form-item label="所属供应商">
                <el-select v-model="item.supplier_id" filterable clearable placeholder="请所属供应商" size="small">
                    <el-option
                            v-for="item in options_supplier"
                            :key="item.value"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit" size="medium">查询</el-button>
<!--                <el-button type="primary" @click="excelOut" size="medium">批量导入</el-button>-->
                <el-button type="primary" @click="excelOut" size="medium">批量导出</el-button>
            </el-form-item>
        </el-form>
        <div class="btns">
            <el-button type="danger" size="small" @click="updateAll" v-auth="['admin/product/detail']">批量修改价格</el-button>
            <el-button type="primary" size="small" @click="upper" v-auth="['admin/goods/upper']">上架</el-button>
            <el-button type="danger" size="small" @click="downer" v-auth="['admin/goods/downer']">下架</el-button>
        </div>
        <!--		:data="list"数据-->
        <el-table :data="list" border @selection-change="handleSelectionChange">
            <!--			这里 prop scope传值-->
            <el-table-column type="selection" align="center"></el-table-column>
			<!-- <el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column> -->
			<el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>

			<el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column label="商品图片">
                <!--				商品的组件和插槽-->
                <template slot-scope="scope">
                    <div style="display: flex; align-items: center;">
                        <img :src="scope.row.product_pic_main" height="30" style="display: flex; margin-right: 5px;" />
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="productcategory" label="商品分类">
                <template slot-scope="scope" v-if="scope.row.productcategory">
                    {{scope.row.productcategory.name}}
                </template>
            </el-table-column>
            <el-table-column prop="supplier" label="供应商">
                <template slot-scope="scope" v-if="scope.row.supplier">
                    {{scope.row.supplier.name}}
                </template>
            </el-table-column>
            <el-table-column prop="supplier" label="平台加价">
                <template slot-scope="scope">
                    {{scope.row.platform_add_price}}
                </template>
            </el-table-column>
            <el-table-column prop="sku_no" label="商品编码">
                <template slot-scope="scope">
                    {{scope.row.sku_no}}
                </template>
            </el-table-column>
            <el-table-column prop="price_min" label="商品价格">
                <template slot-scope="scope">
                    {{scope.row.price_min}}
                </template>
            </el-table-column>
			<el-table-column label="状态" align="center">
				<!--			价格模板插槽	-->
				<template slot-scope="scope">
					<el-tag size="small" type="success" v-if="scope.row.is_marketable">
						已上架
					</el-tag>
					<el-tag size="small" type="danger" v-else>
						已下架
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="created_date" label="添加时间" align="center"></el-table-column>
			<el-table-column prop="last_modified_date" label="更新时间" align="center"></el-table-column>

            <el-table-column label="操作" align="center" width="200">
                <template slot-scope="scope">
                    <!--					传ID过去修改-->
                    <el-button size="mini" type="primary" @click="edit(scope.row.id)" v-auth="['admin/product/detail']">查看</el-button>
                    <el-button size="mini" style="margin-left: 10px !important; " type="danger"  @click="changePrice(scope.row)" v-auth="['admin/product/detail']">修改价格</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--		页码-->
        <el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page" :current-page.sync="pageNum"
        	:page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
        	layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        <!-- 价格 -->
        <el-dialog title="修改价格" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
			<span>
				<span>商品名称：{{propName}}</span>
				<span style="margin-left: 20px;color: red">原金额：{{propPrice}}</span>
				<span style="display: flex;align-items: center;margin-top: 20px;">
					<span style="flex-shrink: 0;margin-right: 10px;">提价金额(元)</span>
					<el-input v-model="platform_add_price" placeholder="提价金额" style="flex-grow: 1;"></el-input>
				</span>
			</span>
            <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="sureSub">确 定</el-button>
			</span>
        </el-dialog>
        <el-dialog title="批量修改价格" :visible.sync="dialogBatchVisible" width="30%" :before-close="handleClose">
			<span>
				<span style="display: flex;align-items: center;margin-top: 20px;">
					<span style="flex-shrink: 0;margin-right: 10px;">提价金额(元)</span>
					<el-input v-model="platform_add_price" placeholder="提价金额" style="flex-grow: 1;"></el-input>
				</span>
			</span>
            <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="sureSub2">确 定</el-button>
			</span>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'Menu',
        data() {
            return {
                // 商品数据
                list: [],
                isLoad: false,
				pageNum: 0,
                pageSize: 20,
                total: 0,
                page: 1,
                thumb: [],
                // 查询
                item: {
                    page: 1,
                    limit: 20,
                    authStatus: 1,
                    goodsStatus: '0'
                },
                options_supplier: [],
                optionsProduct: [],
                filterProps: {
                    value: 'id',
                    label: 'name',
                    emitPath: false,
                    checkStrictly: true
                },
                propName: '',
                propPrice: 0,
                platform_add_price: 0,
                dialogBatchVisible: false,
                dialogVisible: false,
            }
        },
        created() {

            this.getData()
            this.loadList()
			
        },
        methods: {
			gotopage(url){
				console.log(url);
				var link =  this.$router.resolve({
				    path: url,
					query: {
						page: this.item.page
					}
				});
				window.open(link.href, '_blank')
			},
            changePrice(row) {
                this.dialogVisible = true
                this.propName = row.name
                this.propPrice = row.platform_add_price
                this.platform_add_price = row.platform_add_price
                this.propId = row.id
            },
            handleClose(done) {
                this.dialogVisible = false
                this.dialogBatchVisible = false
                this.platform_add_price = ''
            },
            updateAll: function () {
                let id = []
                for (let key in this.multipleSelection) {
                    let item = this.multipleSelection[key]
                    id.push(item.id)
                }
                if (id.length == 0) {
                    this.$message.error({
                        message: '请选择商品',
                        showClose: false
                    });
                    return false;
                }
                this.platform_add_price = ''
                this.dialogBatchVisible = true
            },
            sureSubPost (id) {
                this.platform_add_price = parseFloat(this.platform_add_price)
                this.axios.post('/admin/product/setAddPrice', {
                    id: id,
                    platform_add_price: this.platform_add_price,
                })
                .then(() => {
                    this.price = ''
                    this.$message.success({
                        message: '操作成功'
                    });
                    this.loadList()
                    this.dialogVisible = false
                    this.dialogBatchVisible = false
                })
                .catch(() => {
                    this.price = ''
                    this.selectStoreCategory = ''
                })
            },
            sureSub() {
                this.sureSubPost(this.propId)
            },
            sureSub2: function () {
                let id = []
                for (let key in this.multipleSelection) {
                    let item = this.multipleSelection[key]
                    id.push(item.id)
                }
                if (id.length == 0) {
                    return this.$message.error('请选择商品')
                }
                this.sureSubPost(id)
            },
            getData() {
                this.axios.post('/admin/supplier/list', {
                    pagesize: 0
                }).then(res => {
					this.options_supplier = res.data.list;
                    return this.axios.get('/admin/data/getCategoryTreeAdmin', {
                    })
                }).then(res => {
                    this.optionsProduct = res.data.list
                })
            },
            // 获取数据
            loadList(e) {
				if(e){
					this.item.goodsStatus = e
				}
				console.log('loadlist:',e)
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
				if(this.$route.query.page>0){
					this.item.page =  this.$route.query.page
					this.pageReload(this.$route.query.page)
				}
			 // console.log(this.$route.query.page)
			 //  console.log(this.page)
                //	将页码传到/Goods/index
                this.axios.post('/admin/product/listForSupplierPass', this.item)
                    .then(res => {
                        this.isLoad = !this.isLoad
                        // 后端返回的商品数据列表
                        this.list = res.data.list.data
                        this.total = res.data.list.total
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },

            // 带着商品ID跳转
            edit(id) {
                // this.$router.replace('detail')
                var link =  this.$router.resolve({
                    path: '/Goods/edit.html',
                    query: {
                        id: id,
						//page: this.item.page
                    }
                });
                window.open(link.href, '_blank')
            },

            del(id) {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                // ajax删除 先将要删除数据的ID传过去  执行删除
                this.axios.delete('/admin/product/shopsProduct/delete', {
                    data: [
                        id
                    ]
                })
                .then(() => {
                    this.isLoad = !this.isLoad
                    this.$message.success({
                        message: '删除成功',
                        showClose: false
                    });
                    // 重新获取数据
                    this.loadList()
                })
                .catch(() => {
                    this.isLoad = !this.isLoad
                })
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            upper() {
                let id = []
                for (let key in this.multipleSelection) {
                    let item = this.multipleSelection[key]
                    id.push(item.id)
                }
                if (id.length == 0) {
                    this.$message.error({
                        message: '请选择商品',
                        showClose: false
                    });
                    return false;
                }
                if (this.isLoad) {
                    return false;
                }
                this.isLoad = !this.isLoad
                this.axios.delete('/admin/product/upper', {
                    data: {id: id, in_store: 0}
                }).then(() => {
                    this.isLoad = false
                    this.$message.success({
                        message: '上架成功',
                        showClose: false
                    });
                    this.loadList()
                })
                .catch(() => {
                    this.isLoad = false
                })
            },
            downer() {
                let id = []
                for (let key in this.multipleSelection) {
                    let item = this.multipleSelection[key]
                    id.push(item.id)
                }
                if (id.length == 0) {
                    this.$message.error({
                        message: '请选择商品',
                        showClose: false
                    });
                    return false;
                }

                if (this.isLoad) {
                    return false;
                }

                this.isLoad = !this.isLoad
                this.axios.delete('/admin/product/downer', {
                    data: {id: id, in_store: 0}
                }).then(() => {
                    this.isLoad = false
                    this.$message.success({
                        message: '下架成功',
                        showClose: false
                    });
                    this.loadList()
                })
                .catch(() => {
                    this.isLoad = false
                })
            },
            delAll() {
                let id = []
                for (let key in this.multipleSelection) {
                    let item = this.multipleSelection[key]
                    id.push(item.id)
                }
                if (id.length == 0) {
                    this.$message.error({
                        message: '请选择商品',
                        showClose: false
                    });
                    return false;
                }

                if (this.isLoad) {
                    return false;
                }
                this.isLoad = !this.isLoad
                this.axios.delete('/admin/product/delete', {
                    data: {
                        id: id
                    }
                }).then(() => {
                    this.isLoad = false
                    this.$message.success({
                        message: '删除成功',
                        showClose: false
                    });
                    this.loadList()
                })
                .catch(() => {
                    this.isLoad = false
                })
            },
            //sizeReload 共多少条为一页
            sizeReload(val) {
                this.pageSize = val
                this.item = {
                		page: 1,
                		limit: this.pageSize,
                		authStatus: 1,
						goodsStatus:this.item.goodsStatus
                },
				this.pageNum = 1;
                this.getData()
                this.loadList(this.item.goodsStatus)
            },
            // 前往第几页
            pageReload(val) {
				console.log(this.item.goodsStatus);
				// this.$router.push('/Goods/index.html');
                // this.page = parseInt(val);
                this.item.page = parseInt(val);
                // this.pageNum = parseInt(val);
                this.loadList(this.item.goodsStatus)
            },
            // 搜索查询
            submit(e) {
				this.item.goodsStatus = e
				this.pageNum = 1
                this.item.page = 1
                this.loadList(e)
            },
            // 导出
            excelOut() {
                if (this.isLoad) {
                    return false
                }
				let id = []
				for (let key in this.multipleSelection) {
				    let item = this.multipleSelection[key]
				    id.push(item.id)
				}
				this.item.id = id
                this.isLoad = true
				
                setTimeout(function () {
                    this.isLoad = false
                }.bind(this), 100000);
                this.axios.post('/admin/product/listForSupplierPassExport', this.item)
                    .then(res => {
                        this.isLoad = false
                        if (res.code == 1) {
							const a = document.createElement('a')
							a.href = this.app_url+'./down/'+res.data.filename // 这里的请求方式为get，如果需要认证，接口上需要带上token
							a.click()
							return false;
                            import('@/vendor/Export2Excel.js').then(excel => {
                                var expCellName = res.data.expCellName
                                var tHeader = []
                                var filterVal = []
                                for (var i in expCellName) {
                                    tHeader.push(expCellName[i])
                                    filterVal.push(i)
                                }
                                const expTableData = res.data.expTableData
                                const data = this.formatJson(filterVal, expTableData)
                                var d = new Date()
                                var year = d.getFullYear()
                                var month = d.getMonth()
                                var date = d.getDate()
                                var hour = d.getHours()
                                var minute = d.getMinutes()
                                var second = d.getSeconds()
                                month = month < 10 ? '0' + month : month
                                date = date < 10 ? '0' + date : date
                                hour = hour < 10 ? '0' + hour : hour
                                minute = minute < 10 ? '0' + minute : minute
                                second = second < 10 ? '0' + second : second
                                excel.export_json_to_excel({
                                    header: tHeader,
                                    data,
                                    filename: '供应商商品导出_' + year + '' + month + '' + date + '' + hour + '' + minute + '' + second,
                                    autoWidth: this.autoWidth,
                                    bookType: this.bookType
                                })
                            })
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 3 * 1000
                            })
                        }
                    })
            },
            formatJson (filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => {
                    return v[j]
                }))
            },
        }
    }
</script>
<style scoped>
</style>
